import { navigate } from 'gatsby'
import { getCookie } from 'src/utils/cookies'
import { hasQuickFilters } from 'src/utils/plp/QuickFilters'

export const applySearchState = (url: URL) => {
  const zipCode = getCookie('postalCode')

  const link = `${url.pathname}${url.search}${
    hasQuickFilters(url.search) && zipCode ? `&zipCode=${zipCode}` : ''
  }`

  navigate(link)
}
